import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import RequireCategory from '../admin/settings/RequireCategory';

const DirectorAgentsPage = lazyRetry(() => import('./DirectorAgentsPage'));

// Needs the AGENTS group permission, matching the nav filter in NavigationLoader.
const DirectorAgentsRoute: FuseRouteItemType = {
  path: 'agents',
  element: (
    <RequireCategory category="agents">
      <DirectorAgentsPage />
    </RequireCategory>
  )
};

export default DirectorAgentsRoute;
